var _clipPath, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSentinelone = function SvgSentinelone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1272 1589"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "sentinelone_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.44 0h8396.73v1588.67H-10.44z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sentinelone_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4500b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6100ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sentinelone_svg__a",
    id: "sentinelone_svg__e",
    x2: 1,
    gradientTransform: "matrix(-631.364 -316.068 105.623 -210.989 1266.698 474.952)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sentinelone_svg__a",
    id: "sentinelone_svg__g",
    x2: 1,
    gradientTransform: "matrix(-631.364 316.07 -105.622 -210.984 1266.698 1113.717)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sentinelone_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6100ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500b6"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sentinelone_svg__b",
    id: "sentinelone_svg__h",
    x2: 1,
    gradientTransform: "matrix(631.363 -316.068 105.624 210.989 4.565 474.952)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sentinelone_svg__b",
    id: "sentinelone_svg__i",
    x2: 1,
    gradientTransform: "matrix(631.363 316.07 -105.622 210.984 4.565 1113.717)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sentinelone_svg__b",
    id: "sentinelone_svg__j",
    x2: 1,
    gradientTransform: "matrix(-683.229 -342.062 105.672 -211.068 974.59 964.002)",
    gradientUnits: "userSpaceOnUse"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sentinelone_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sentinelone_svg__e)",
    d: "m635.6 318.4 635.6 317.8V317.8L635.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sentinelone_svg__g)",
    d: "m635.6 1270.2 635.6-317.7v318.4l-635.6 317.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sentinelone_svg__h)",
    d: "M635.6 318.4.1 636.2V317.8L635.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sentinelone_svg__i)",
    d: "M635.6 1270.2.1 952.5v318.4l635.5 317.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sentinelone_svg__j)",
    d: "m158.9 715.1 635 317.6 318.3-159.3-634.8-317.3z"
  }))));
};
export default SvgSentinelone;